import session from '../../auth_api/session'
import Vue from 'vue'

const URL = process.env.VUE_APP_API_URL
const appURL = URL + 'gku_reestr/api/'

export default {
  namespaced: true,
  state: {
    accounts: { 'results': [] },
    receipts: { 'results': [] },
    receipt: {},
    default_receipt: {
      id: null,
      oplata: null,
      norm: null,
      tariff: null,
      service: null,
      address: null,
      create_date: null,
      time_stamp: null,
      user: ''
    },
    address: {},
    services: [],
    search: {
      boroughSubFed_id: null,
      super_town_id: null,
      town_id: null,
      street_id: null,
      houseNumber: '',
      building: '',
      flatNumber: '',
      period_pay: new Date().toISOString().substr(0, 8) + '01',
      new_search: false // При новых параметрах фильтра ставим true и сбрасываем pagination.page до 1
    },
    pagination: {
      rowsPerPage: 10,
      sortBy: null,
      totalItems: 0,
      page: 1
    }
  },
  mutations: {
    setAccounts (state, payload) {
      state.accounts = payload
    },
    setReceipts (state, payload) {
      state.receipts = payload
    },
    setReceipt (state, payload) {
      state.receipt = payload
    },
    setDefaultReceipt (state) {
      state.receipt = Object.assign({}, state.default_receipt)
    },
    setAddress (state, payload) {
      state.address = payload
    },
    setServices (state, payload) {
      state.services = payload
    },
    clearSearchPage (state) {
      if (state.search.new_search) {
        Vue.set(state.search, 'new_search', false)
        Vue.set(state.pagination, 'page', 1)
      }
    }
  },
  actions: {
    fetchAccounts ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'fetchAccounts'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        if ((0 + payload.pagination.page > 1) && !payload.search.new_search) {
          params['page'] = payload.pagination.page
        }
        params['period_pay'] = payload.search.period_pay.substr(0, 7)
        if (payload.search.boroughSubFed_id) {
          params['boroughSubFed_id'] = payload.search.boroughSubFed_id
        }
        if (payload.search.super_town_id) {
          params['super_town_id'] = payload.search.super_town_id
        }
        if (payload.search.town_id) {
          params['town_id'] = payload.search.town_id
        }
        if (payload.search.street_id) {
          params['street_id'] = payload.search.street_id
        }
        if (payload.search.houseNumber > '') {
          params['house'] = payload.search.houseNumber
        }
        if (payload.search.building > '') {
          params['building'] = payload.search.building
        }
        if (payload.search.flatNumber > '') {
          params['flat'] = payload.search.flatNumber
        }
        let _url = appURL + 'accounts/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setAccounts', response.data)
            commit('clearSearchPage')
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchReceipts ({ commit, dispatch }, addressId) {
      return new Promise((resolve, reject) => {
        const loaderName = 'fetchReceipts'
        // commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        params['address_id'] = addressId
        let _url = appURL + 'receipt/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setReceipts', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchAddress ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'fetchAddress'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'address/' + payload.period_pay + '/' + payload.account + '/'
        session.get(_url)
          .then(response => {
            commit('setAddress', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchServices ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const loaderName = 'fetchServices'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'service/'
        session.get(_url)
          .then(response => {
            commit('setServices', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    insertReceipt ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gku_insertReceipt_' + payload.id
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        // TODO: Код не очень
        const data = new FormData()
        data.append('oplata', payload.oplata)
        data.append('norm', payload.norm)
        data.append('tariff', payload.tariff)
        data.append('service', payload.service)
        data.append('address', payload.address)
        let _url, method
        if (payload.id === null) {
          _url = appURL + 'receipt/'
          method = 'post'
        } else {
          data.append('id', payload.id)
          _url = appURL + 'receipt/' + payload.id + '/'
          method = 'patch'
        }

        session({ method: method, url: _url, data: data, headers: { 'Content-Type': 'multipart/form-data' } }
        )
          .then(response => {
            commit('setReceipt', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    deleteReceipt ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gku_deleteReceipt_' + payload
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'receipt/' + payload + '/'
        session.delete(_url)
          .then(function () {
            commit('setDefaultReceipt')
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    accounts (state) {
      return state.accounts
    },
    receipts (state) {
      return state.receipts
    },
    receipt (state) {
      return state.receipt
    },
    address (state) {
      return state.address
    },
    services (state) {
      return state.services
    },
    search (state) {
      return state.search
    },
    pagination (state) {
      return state.pagination
    }
  }
}
